import { render, staticRenderFns } from "./New Form.vue?vue&type=template&id=4b85942b&scoped=true&"
import script from "./New Form.vue?vue&type=script&lang=js&"
export * from "./New Form.vue?vue&type=script&lang=js&"
import style0 from "./New Form.vue?vue&type=style&index=0&id=4b85942b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85942b",
  null
  
)

export default component.exports